import React,{ Component } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  Input,
  FormGroup,
  Label
} from 'reactstrap';

import Form from '../../../shared/components/Form';
import TextInput from '../../../shared/components/TextInput';
import MoneyInput from '../../../shared/components/MoneyInput';
import Button from '../../../shared/components/Button';
import PaymentForm from '../../../shared/components/PaymentForm';

const CREATE_NEW_PAYMENT_METHOD_OPTION = '__CREATE_NEW_PAYMENT_METHOD_OPTION__',
  CREATE_NEW_INVOICE_METHOD_OPTION = '__CREATE_NEW_INVOICE_METHOD_OPTION__',
  CREATE_NEW_ADJOY_PAYS_METHOD_OPTION = '__CREATE_NEW_ADJOY_PAYS_METHOD_OPTION__',
  CURRENT_BALANCE_METHOD_OPTION = '__CURRENT_BALANCE_METHOD_OPTION__';


class AccountNewPaymentMethod extends Component {
  constructor(){
    super();

    this.state = {
      isLoaded:false,
      error:null
    };
  }

  componentDidMount(){
    //TODO: Load data from server for AccountNewPaymentMethod in componentDidMount
    Promise
      .all([])
      .then(() => this.setState({isLoaded:true}))
      .catch((err) => this.setState({error:err}));
  }

  componentWillUnmount(){
    //TODO: Cleanup after AccountNewPaymentMethod in componentWillUnmount
  }

  handleSubmit(data){
    const { redirectURL, accountId, history, createPaymentMethod } = this.props;

    createPaymentMethod({
      token:data.token,
      last4:data.last4,
      kind:data.kind,
      agencyId:accountId
    })
      .then(() => history.push(redirectURL ? redirectURL : `/superadmin/accounts/${accountId}/paymentMethods`))
  }

  render(){
    //TODO: Render AccountNewPaymentMethod
    const { redirectURL, accountId, history } = this.props;

    return (
      <div className='AccountNewPaymentMethod'>
        <Row>
          <Col xs='12' md='6'>
            <br />
            <h3>New Payment Method</h3>
            <br />
            <PaymentForm 
              showSuperadminFeatures
              allowCreateNewMethod
              showCancelButton
              onSubmit={(data) => this.handleSubmit(data)}
              onCancel={() => history.push(redirectURL ? redirectURL : `/superadmin/accounts/${accountId}/paymentMethods`)}
            />
            <br />
            <br />
          </Col>
        </Row>
      </div>
    );
  }
}

AccountNewPaymentMethod.propTypes = {
  //TODO: Fill in prop types for AccountNewPaymentMethod
};

AccountNewPaymentMethod.defaultProps = {
  //TODO: Fill in defaultProps for AccountNewPaymentMethod
};

export default AccountNewPaymentMethod;



// WEBPACK FOOTER //
// ./src/routes/AccountNewPaymentMethod/components/AccountNewPaymentMethod.js